import { isEmail } from '@albacross/frontend-utils'

export const loginValidator = values => {
  const errors: Record<string, any> = {}

  if (!values.email) {
    errors.email = 'E-mail is required'
  } else if (!isEmail(values.email)) {
    errors.email = 'E-mail is invalid'
  }

  if (!values.password) errors.password = 'Password is required'

  return errors
}
